import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext"; // Icono separador
import Breadcrumbs from "@mui/material/Breadcrumbs";
import MuiLink from "@mui/material/Link"; // Renombramos el Link de MUI
import Typography from "@mui/material/Typography";
import React from "react";
import { Link as RouterLink } from "react-router-dom"; // Importamos el Link de Router

/**
 * Este componente acepta la página actual como prop
 * @param {{ currentPage: string }} props
 */
const AppBreadcrumbs = ({ steps, currentPage }) => {
  return (
    // 'sx={{ mb: 2 }}' añade un margen inferior
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      sx={{ mb: 2 }}
    >
      {/* 1. Enlace a "Home" (siempre presente) */}
      <MuiLink
        component={RouterLink}
        to="/"
        underline="hover"
        color="inherit"
        sx={{ display: "flex", alignItems: "center" }}
      >
        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
        Home
      </MuiLink>

      {steps
        ? steps.map((step, _) => (
          <MuiLink
            component={RouterLink}
            to={step.to}
            underline="hover"
            color="inherit"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            {step.label}
          </MuiLink>
        ))
        : null}

      {/* 2. Página Actual (no es un enlace) */}
      <Typography color="text.primary">{currentPage}</Typography>
    </Breadcrumbs>
  );
};

export default AppBreadcrumbs;
